var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLockIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 19,
  fill: "none",
  viewBox: "0 0 17 19",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#9794AA",
  d: "M15.75 8.25h-1.594V3a3 3 0 0 0-3-3H5.344a3 3 0 0 0-3 3v5.25H.75A.75.75 0 0 0 0 9v9c0 .415.335.75.75.75h15a.75.75 0 0 0 .75-.75V9a.75.75 0 0 0-.75-.75M4.031 3c0-.724.589-1.312 1.313-1.312h5.812c.724 0 1.313.588 1.313 1.312v5.25H4.03zm10.782 14.063H1.688V9.938h13.125zm-7.22-3.258v1.242c0 .103.085.187.188.187h.938a.19.19 0 0 0 .187-.187v-1.242a1.125 1.125 0 1 0-1.312 0"
})));
export { SvgLockIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/lock_icon.svg";